import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam, IExamCategory } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-copy',
  templateUrl: './exam-copy.component.html',
  styleUrls: ['./exam-copy.component.scss']
})
export class ExamCopyComponent implements OnInit {
  exam: IExam = examDefault;

  examFromId: number;
  examList: Array<IExam>;
  categoryList: IExamCategory[] = [];
  category: any;

  constructor(private popoverRef: PopoverRef<ExamCopyComponent>,
    private examService: ExamService, private snackBar: SnackbarService,) { }

  async ngOnInit() {

  
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
      let examCat =  this.examService.getExamCategories(this.exam.id).then((categories: any) => {
        this.categoryList = categories;
      });
      await this.examService.getAllExams().then(async(exams: any) => {
        this.examList = exams;
        this.examList = this.examList.filter(item => item.id != this.exam.id);
        await examCat;
      }).catch((e) => {
        // this.snackBar.open(e, 'Error', {
        //   duration: 3000,
        //   horizontalPosition: 'right', verticalPosition: 'top'
        // });
        console.log(e);
      });
    }
  }

  close() {
    this.popoverRef.close();
  }
  async copyQuestions() {
    if (this.examFromId == 0) {
      this.snackBar.warning('No Examination Selected to copy from');
      return;
    }
    let data = {
      fromExamId: this.examFromId,
      toExamId: this.exam.id,
      category: this.category
    }
    await this.examService.copyExam(data).then((res: any) => {
      this.snackBar.success('Questions copied successfully');
      this.popoverRef.close();

      this.close();
    });


  }
}
